$('.tab-btn-switcher').on('click', function() {
  $('.tab-btn-switcher').removeClass('active');
  $(this).addClass('active');
});

$('.tab-card-view-btn').on('click', function() {
  var $wrapper = $(this).parents('.aad-admin-pledge-history');

  $wrapper.find('.tab-content').removeClass('chart-view').addClass('card-view');
  $wrapper.find('.tab-content').find('.row').removeClass('flex-row-reverse').removeClass('justify-content-between');
});

$('.tab-cart-view-btn').on('click', function() {
  var $wrapper = $(this).parents('.aad-admin-pledge-history');

  $wrapper.find('.tab-content').addClass('chart-view').removeClass('card-view');
  $wrapper.find('.tab-content').find('.row').addClass('flex-row-reverse').addClass('justify-content-between');
});